import { Spinner } from '@lawpilots/design-system'
import { Box } from '@mui/material'
import { ReactNode } from 'react'

type LoadingPanelProps = {
  /** Defaults to true so the panel drops straight into a Suspense fallback. */
  loading?: boolean
  label: string
  children?: ReactNode
}

const WellStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: 200,
  width: '100%',
}

export const LoadingPanel = ({ loading = true, label, children = null }: LoadingPanelProps): JSX.Element =>
  loading ? (
    <Box sx={WellStyles}>
      <Spinner size="lg" label={label} />
    </Box>
  ) : (
    <>{children}</>
  )
